import {request} from "@/network/request";
import qs from "qs";
const scope = 'server'

export function Login(username,password){
  let grant_type = 'password'
  let dataObj = qs.stringify({'username': username, 'password': password,'scope':scope})
  return request({
    url:'/auth/oauth/token',
    headers: {
      isToken:false,
      'Authorization': 'Basic dGVzdDp0ZXN0',
      "Content-Type": 'application/x-www-form-urlencoded;charset=utf-8'
    },
    method: 'post',
    params: {grant_type},
    data: dataObj
  })
}
export const refreshToken = (refresh_token) => {
  const grant_type = 'refresh_token'
  return request({
    url: '/auth/oauth/token',
    headers: {
      isToken: false,
      'Authorization': 'Basic dGVzdDp0ZXN0',
      "Content-Type": 'application/x-www-form-urlencoded;charset=utf-8'
    },
    method: 'post',
    params: {grant_type,scope,refresh_token}
  })
}
export const logout = () => {
  return request({
    url: '/auth/token/logout',
    method: 'delete'
  })
}
export const getDeptTree = () =>{
  return request({
    url:'/admin/dept/tree',
    method:'get'
  })
}
export const getUserInfo = () =>{
  return request({
    url:'/admin/user/info',
    method:'get',
  })
}
export const editPassword = (data) =>{
  return request({
    url:'/admin/user/editPassword',
    method:'put',
    data:data
  })
}